var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3014_11839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.625 22.0001C2.46667 22.0001 2.30417 21.9376 2.18334 21.8167C1.9375 21.5709 1.9375 21.1751 2.18334 20.9334L20.9333 2.1834C21.1792 1.93757 21.575 1.93757 21.8167 2.1834C22.0625 2.42923 22.0625 2.82507 21.8167 3.06673L3.06667 21.8167C2.94584 21.9376 2.78334 22.0001 2.625 22.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.375 22.0001C21.2167 22.0001 21.0542 21.9376 20.9333 21.8167L2.18334 3.06673C1.9375 2.82507 1.9375 2.42507 2.18334 2.1834C2.42917 1.93757 2.82084 1.93757 3.06667 2.1834L21.8167 20.9334C22.0625 21.1792 22.0625 21.5751 21.8167 21.8167C21.6958 21.9376 21.5333 22.0001 21.375 22.0001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3014_11839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.f75b8f1b0186fe3a2f3dc67eeb40995e.svg";
export { ForwardRef as ReactComponent };